// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC1O1vfPGtQSoG3qF1Io4Y2JlqRKq0ojoc",
  authDomain: "scenes-84b3f.firebaseapp.com",
  projectId: "scenes-84b3f",
  storageBucket: "scenes-84b3f.appspot.com",
  messagingSenderId: "814330701685",
  appId: "1:814330701685:web:9ae3f5ec27ea4c97c3953c",
  measurementId: "G-TQCRDPF7YT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);
